import { lazy, Suspense, useEffect, useState, type ComponentProps } from "react";

const BookingDialog = lazy(() =>
  import("@/components/site/BookingDialog").then((m) => ({ default: m.BookingDialog })),
);

type LazyBookingDialogProps = ComponentProps<typeof BookingDialog>;

/** Defers booking/dialog code until the user opens it. */
export const LazyBookingDialog = (props: LazyBookingDialogProps) => {
  const [shouldLoad, setShouldLoad] = useState(props.open);

  useEffect(() => {
    if (props.open) setShouldLoad(true);
  }, [props.open]);

  if (!shouldLoad) return null;

  return (
    <Suspense fallback={null}>
      <BookingDialog {...props} />
    </Suspense>
  );
};
